import Api from '@/services/Api'

export default {
    getAllActivosContratos(){
        return Api().get('contratoActivos/getAll')
    },
    getActivoContratoByNumContr(nroContract){
        return Api().get('contratoActivos/contratoActivoByNumContrato/'+nroContract)
    },
    createContratoActivo(datos){
        return Api().post('contratoActivos/create',datos)
    },
    // updateTasaById(datos){
    //     return Api().put('tasa/update',datos)
    // },
    // deleteTasa(id){
    //     return Api().delete('tasa/delete/'+id)
    // }
}